const snackBarSettings = {
  position: "top-center",
  style: {
    fontFamily: "Goldplay",
    fontSize: "1.25rem",
    textAlign: "center",
    fontWeight: "600",
    padding: "1.5rem",
    backgroundColor: "#f96e67",
  },
  closeStyle: {
    display: "none",
  },
}

export default snackBarSettings
